import { TFunction } from 'react-i18next';

export enum Location {
  'UK' = 'UK',
  'Germany_Austria_Switzerland_Netherlands' = 'Germany_Austria_Switzerland_Netherlands',
  'Rest_of_Europe' = 'Rest_of_Europe',
  'Rest_of_the_World' = 'Rest_of_the_World',
}

export const allLocations = Object.keys(Location);

const labelMap: { [key in Location]: string } = {
  UK: 'UK',
  Germany_Austria_Switzerland_Netherlands: 'GermanyAustriaSwitzerlandOrNetherlands',
  Rest_of_Europe: 'RestOfEurope',
  Rest_of_the_World: 'RestOfTheWorld',
};

export const getReadableLabel = (location: Location, translator: TFunction<'campaigns'>): string =>
  translator(`editor.geolocation.locations.${labelMap[location]}`);

export interface Geolocation {
  type?: '.Geolocation';
  location?: Location;
}
